var render = function (_h,_vm) {var _c=_vm._c;return _c('label',{staticClass:"badge badge-pill trusted-status"},[_vm._v(" "+_vm._s(_vm.parent.$it('no-assets.label.title', 'No assets'))+" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }